<h2 mat-dialog-title>Permissões de acesso</h2>
<div mat-dialog-content>
    <div fxLayout="row wrap" *ngIf="modulos.length <= 0">
        <div fxFlex.gt-sm="100" fxFlex="100" class="p-10">
            <p>
                {{messageModulos}}
            </p>
        </div>
    </div>
    <div fxLayout="row wrap" *ngFor="let modulo of modulos">
        <div fxFlex.gt-sm="100" fxFlex="100" class="p-10">
            <h2>{{modulo.nome}}</h2>
            <mat-divider></mat-divider>
        </div>
        <div fxFlex.gt-sm="100" fxFlex="100" class="p-10" *ngIf="modulo.permissoes.length <= 0">
            <p>
                Este módulo não possui permissões disponíveis.
            </p>
        </div>
        <div fxFlex.gt-sm="50" fxFlex="100" class="p-10" *ngFor="let permissao of modulo.permissoes">
            <p>
                <mat-checkbox 
                    class="p-10" 
                    [labelPosition]="'after'" 
                    [checked]="isCheckedModulo(permissao)" 
                    (change)="onChangePermissao($event,permissao.id)"
                >
                    {{permissao.nome}}
                </mat-checkbox>
            </p>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="salvar()" tabindex="-1">Salvar</button>
</div>
